module.exports = __webpack_public_path__ + "static/media/3.dbf82c38.png";